import './App.css';
import VDice from './components/VDice'
import SelectView from './components/SelectView'
import Credit from "./components/Credit";


function App() {
  return (
    <div className="App">
      {/* <SelectView></SelectView> */}
      <VDice></VDice>
    </div>
  );
}

export default App;
